'use client';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@/primitives';
import { TRAIT_LEADER_EXPLANATION } from './traitLeader';

type TraitLeaderInfoModalProps = {
  open: boolean;
  onClose: () => void;
};

export default function TraitLeaderInfoModal({
  open,
  onClose,
}: TraitLeaderInfoModalProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>BREEDPLAN trait leaders</DialogTitle>
      <DialogContent>
        <Typography variant="bodymedium">{TRAIT_LEADER_EXPLANATION}</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="outlined" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
